import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import './SubscriptionInput.scss';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCaretRight, faCaretDown } from '@fortawesome/free-solid-svg-icons';

class GroupSubscriptionInput extends React.Component {
  constructor(props) {
    super(props);
    // const checked = props.checked;
    const { selectedGroupIds, groups } = this.props;
    const subChildren = _.reduce(
      groups.groups,
      (acc, node) => {
        if (!node) {
          return {};
        }
        acc[node.id] = !!_.includes(selectedGroupIds, node.id);
        return acc;
      },
      {},
    );
    let isChildsChecked = false;
    const getCollapseStatus = (arry) => {
      if (arry !== null) {
        arry.forEach((item) => {
          if (_.includes(selectedGroupIds, Number(item.id))) {
            return isChildsChecked = true;
          }
          return getCollapseStatus(item.groups);
        });
      }
    };
    if (groups !== null) {
      getCollapseStatus(groups.groups);
    }


    this.state = {
      checked: _.includes(selectedGroupIds, groups.id),
      collapsed: true,
      subChildren,
      toggleParent: false,
      collapseTouched: false
    };
    this.handleInputChange = this.handleInputChange.bind(this);
    this.updateStateSync = this.updateStateSync.bind(this);
    this.handleInputChangeForParent = this.handleInputChangeForParent.bind(this);
    this.handleCollapseIconClick = this.handleCollapseIconClick.bind(this);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { checked, groups, setGroupData } = this.props;
    const { subChildren, toggleParent, collapsed } = this.state;
    const diffChecked = checked !== nextProps.checked;
    if (diffChecked) {
      const hasOneChild = _.size(groups.groups) === 1;
      let newChildren = subChildren;
      if (!toggleParent || hasOneChild || !nextProps.synToggleParentFlag) {
        newChildren = _.mapValues(subChildren, (value, key, object) => nextProps.checked);
      }
      this.synToggleParentFlag = nextProps.synToggleParentFlag;
      setGroupData(newChildren);
      this.setState({
        checked: nextProps.checked,
        subChildren: newChildren,
      });
      if (collapsed) {
        this.handleCollapseIconClick();
      }
    }
  }

  updateStateSync(stateUpdate) {
    return new Promise(resolve => {
      this.setState(stateUpdate, () => resolve())
    })
  }


  async handleInputChange(event) {
    const { handleInputChangeForParent, groups, setGroupData } = this.props;
    const { subChildren, collapsed, collapseTouched } = this.state;
    const { checked } = event.target;

    // cancel the event pooling for the async function
    event.persist()

    if (!collapseTouched) {
      await this.updateStateSync({ collapseTouched: true })
    }

    const thisId = event.target.getAttribute('data-id');
    const checkedObj = {};
    checkedObj[thisId] = checked;
    const newChildren = _.mapValues(subChildren, (value, key, object) => checked);

    this.setState(
      {
        checked,
        subChildren: newChildren, // handle child nodes
        toggleParent: false,
      },
      () => handleInputChangeForParent(checked, groups),
    );
    this.synToggleParentFlag = false;
    setGroupData({ ...checkedObj, ...newChildren });
    if (collapsed) {
      this.handleCollapseIconClick();
    }
  }

  handleInputChangeForParent(checked, childGroups) {
    const { groups, handleInputChangeForParent, setGroupData } = this.props;
    const { subChildren } = this.state;
    const newChildren = { ...subChildren, [childGroups.id]: checked };
    // check to see if the children are checked
    const parentChecked =
      _.chain(newChildren)
        .values()
        .compact()
        .size()
        .value() === _.size(groups.groups);
    const checkedObj = {};
    checkedObj[groups.id] = parentChecked;
    this.setState(
      {
        checked: parentChecked,
        subChildren: newChildren,
        toggleParent: true,
      },
      () => handleInputChangeForParent(parentChecked, groups),
    );
    this.synToggleParentFlag = true;
    setGroupData({ ...checkedObj, ...newChildren });
  }

  handleCollapseIconClick() {
    const { collapsed, collapseTouched } = this.state;
    this.setState({
      collapsed: !collapsed,
      collapseTouched: true,
    });
  }

  render() {
    const {
      isRootElement,
      groups: groupsChildNode,
      selectedGroupIds,
      setGroupData,
      parentTouched
    } = this.props;

    const { checked, collapsed, subChildren, collapseTouched } = this.state;
    const icon = collapsed ? 'fa-caret-right' : 'fa-caret-down';
    const iconClassName = collapsed
      ? 'SubscriptionInput__icon--plus'
      : 'SubscriptionInput__icon--minus';
    const displayCollapseIcon = !_.isNull(_.get(groupsChildNode, null));
    const childrenCount = _.size(groupsChildNode.groups);
    const hasChildren = childrenCount > 0;
    const displayChildrenCount = !isRootElement && hasChildren;
    const oneFlag = groupsChildNode.level === 'one';
    const nameClass = hasChildren || oneFlag ? 'SubscriptionInput__name' : '';
    return (
      <>
        {
          hasChildren &&
          (
            <li className="tree-parent">
              <div className={` ${oneFlag && 'title'} group-sub-div`}>
                {
                  displayCollapseIcon && (
                    <button
                      type="button"
                      onClick={() => this.handleCollapseIconClick()}
                      aria-expanded={!collapsed}
                      aria-label={groupsChildNode.name}
                    >
                      <FontAwesomeIcon
                        icon={collapsed ? faCaretRight : faCaretDown}
                        value={groupsChildNode.name}
                        width="1.275em"
                        height="1.275em"
                      />
                    </button>
                  )}
                <input
                  type="checkbox"
                  data-id={groupsChildNode.id}
                  checked={checked}
                  onChange={this.handleInputChange}
                  aria-label={groupsChildNode.name}
                />
                <span
                  className={nameClass}
                  id={`${groupsChildNode.id}Label`}
                >
                  {groupsChildNode.name}
                  {displayChildrenCount && (
                    <span className={`${nameClass} SubscriptionInput__children--count`}>
                    ({childrenCount})&lrm;
                    </span>
                  )}
                </span>
              </div>
              <div className="haschild">
                {((parentTouched != null) || (collapseTouched)) &&
                <ul style={{ display: collapsed ? 'none' : 'block' }}>
                  {
                    groupsChildNode.groups && _.map(groupsChildNode.groups, (deepChildNode, index) =>
                      <GroupSubscriptionInput
                        key={index}
                        groups={deepChildNode}
                        checked={subChildren[deepChildNode.id]}
                        handleInputChangeForParent={this.handleInputChangeForParent}
                        parentChecked={checked}
                        synToggleParentFlag={this.synToggleParentFlag}
                        selectedGroupIds={selectedGroupIds}
                        setGroupData={setGroupData}
                        parentTouched={collapseTouched}
                      />
                    )}
                </ul>
                }
              </div>
            </li>
          )
        }
        {!hasChildren && (
          <li className="tree-parent">
            <div className={` ${oneFlag && 'title title-no-underline'} group-sub-div1`}>
              <input
                type="checkbox"
                data-id={groupsChildNode.id}
                checked={checked}
                onChange={this.handleInputChange}
                aria-label={groupsChildNode.name}
              />
              <span
                className={nameClass}
                id={`${groupsChildNode.id}Label`}
              >
                {groupsChildNode.name}
              </span>
              {displayChildrenCount && (
                <span className={`${nameClass} SubscriptionInput__children--count`}>
                  ({childrenCount})&lrm;
                </span>
              )}
            </div>
          </li>
        )}
      </>
    );
  }
}

GroupSubscriptionInput.propTypes = {
  isRootElement: PropTypes.bool,
  defaultCollapsed: PropTypes.bool,
  checked: PropTypes.bool,
  groups: PropTypes.shape().isRequired,
  selectedGroupIds: PropTypes.arrayOf(PropTypes.number).isRequired,
  handleInputChangeForParent: PropTypes.func,
  parentChecked: PropTypes.bool,
  setGroupData: PropTypes.func.isRequired,
  synToggleParentFlag: PropTypes.bool,
};

GroupSubscriptionInput.defaultProps = {
  isRootElement: false,
  parentChecked: false,
  defaultCollapsed: true,
  checked: false,
  handleInputChangeForParent: () => { },
  synToggleParentFlag: false,
};

export default GroupSubscriptionInput;
